import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataLake } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const onUpdateDataLakeRetention = ({ streamId, retentionTime }) => DataLake.setArchiveRetentionTime(streamId, {
  retention_time: retentionTime
});
const useDataLakeRetention = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onUpdateDataLakeRetentionMutation } = useMutation({
    mutationFn: onUpdateDataLakeRetention,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake-config"]
      });
      UserNotification.success(
        "Successfully updated Data Lake retention configuration.",
        "Update Data Lake retention configuration"
      );
    },
    onError: (errorThrown) => {
      UserNotification.error(
        `Updating Data Lake retention configuration failed with status: ${errorThrown}`,
        "Could not update Data Lake retention configuration"
      );
    }
  });
  return {
    onUpdateDataLakeRetentionMutation
  };
};
export default useDataLakeRetention;
